module.exports = __webpack_public_path__ + "static/img/service_safeguard_center.33d3a724.svg";